import * as React from 'react';
import { Row, Col } from 'reactstrap';
import Helper from '../../utilities/helper'
import { useLocation } from 'react-router-dom';
import { MyProfile } from './MyProfile';
import { MyFleets } from './MyFleets';
import { useQuery } from "graphql-hooks";
import { Loading } from '../Shared/Loading';
import { useCallback, useEffect, useState } from 'react';
import { EditMyAccount } from './EditMyAccount';
import { useFetchWrapper } from '../../hooks/useFetchWrapper';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { MetaTags } from "../Shared/MetaTags";
import { ErrorPage } from '../Shared/ErrorPage';
import { Hero } from '../Shared/Hero';
import { clientConfig } from '../../utilities/configService';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentBody } from '../Shared/Content/ContentBody';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';


const CMS_QUERY = `query datoQuery {
    pageMyAccount {
        fieldHeroTitle
        fieldProfileSectionTitle
        fieldProfileSectionSubtitle
        fieldEstimatesSectionTitle
        fieldEstimatesSectionSubtitle
        fieldEstimatesSectionNoEstimates
        fieldAssessmentsSectionTitle
        fieldAssessmentsSectionSubtitle
        fieldAssessmentsSectionNoDocuments
        fieldAssessmentsSectionNonParticipant
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
    pageEditMyAccount {
        fieldHeroTitle
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export interface IUserProfile {
    firstName: string,
    lastName: string,
    userName: string,
    email: string,
    title: string,
    jobRoleTypeID: number,
    jobRoleTypeName: string,
    organizationName: string,
    organizationTypeID: number,
    organizationTypeName: string,
    phone: string,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateProvinceRegion: string,
    postalCode: string,
    isParticipant: boolean
}

export const MyAccount = () => {
    const fetchWrapper = useFetchWrapper();
    const [showEditView, setShowEditView] = useState(false);
    const [userProfile, setUserProfile] = useState<IUserProfile>({
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        title: "",
        jobRoleTypeID: 0,
        jobRoleTypeName: "",
        organizationName: "",
        organizationTypeID: 0,
        organizationTypeName: "",
        phone: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateProvinceRegion: "",
        postalCode: "",
        isParticipant: false
    });
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();

    const location = useLocation();
    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    const applicationName = clientConfig?.APPLICATION_NAME || '';

    const getUserProfile = useCallback(() => {
        fetchWrapper.get(`account/${applicationName}`)
            .then((data) => {
                setUserProfile(data);
            });
    }, [applicationName]);

    useEffect(() => {
        getUserProfile();
    }, [getUserProfile]);

    const editMyProfileCallback = () => {
        setShowEditView(true);
    }

    const saveMyProfileCallback = () => {
        setShowEditView(false);
        getUserProfile();
    }

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.MyAccount}>
                <>
                    {!showEditView ? (
                        <div className="myAccount">
                            <Hero pageTitle={data.pageMyAccount.fieldHeroTitle} />
                            <ContentBlock className="myAccountContent">
                                <ContentBody>
                                    <Row className="myAccountContainer">
                                        <Col lg={6} sm={12} className="myProfileContainer">
                                            <MyProfile title={data.pageMyAccount.fieldProfileSectionTitle} subtitle={data.pageMyAccount.fieldProfileSectionSubtitle} userProfile={userProfile} editHandler={editMyProfileCallback} />
                                        </Col>
                                        <Col lg={6} sm={6} className="myFleetsContainer">
                                            <MyFleets title={data.pageMyAccount.fieldEstimatesSectionTitle} subtitle={data.pageMyAccount.fieldEstimatesSectionSubtitle} noDataMessage={data.pageMyAccount.fieldEstimatesSectionNoEstimates} />
                                        </Col>
                                        {/*<Col lg={6} sm={6} className="myDocumentsContainer">*/}
                                        {/*    <MyDocuments title={data.pageMyAccount.fieldAssessmentsSectionTitle} subtitle={data.pageMyAccount.fieldAssessmentsSectionSubtitle} noDataMessage={data.pageMyAccount.fieldAssessmentsSectionNoDocuments} nonParticipantMsg={data.pageMyAccount.fieldAssessmentsSectionNonParticipant} />*/}
                                        {/*</Col>*/}
                                    </Row>
                                </ContentBody>
                            </ContentBlock>
                            <MetaTags seoData={data.pageMyAccount.seo} />
                        </div>
                    ) : (
                        <div className="profileUsContainer">
                            <div className="profileRequest">
                                <Hero pageTitle={data.pageEditMyAccount.fieldHeroTitle} />
                                <EditMyAccount userProfile={userProfile} saveHandler={saveMyProfileCallback} />
                            </div>
                            <MetaTags seoData={data.pageEditMyAccount.seo} />
                        </div>
                    )}
                </>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
